<template>
  <div class="dashboard" >
    <v-container class="my-3">
      <v-layout wrap row justify-start class="mb-3">
        <v-flex xs8 px-2 mb-2 INFLUNECERS>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Influncers invoicing
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t4 = !t4">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t4">
              <v-layout row wrap class="text-xs-left">
                <v-flex xs12 SELECTUSER>
                  <v-autocomplete
                    :items="users.filter(x=>x.role =='influencer')"
                    solo
                    :disabled="loading"
                    :loading="loading"
                    return-object
                    v-model="selectedUser"
                    label="User"
                    @change="setInvoiceVars()"
                    :filter="filterObject"
                  >
                    <template
                      slot="selection"
                      slot-scope="{ item }"
                    >
                      {{item.name}}
                    </template>
                    <template
                      slot="item"
                      slot-scope="{ parent, item }"
                      class="py-1"
                    >
                        <v-list-tile-action>
                          <v-badge right overlap top small  style="transform: scale(0.5);" :color="`${item.access ? 'success' : 'error'}`">
                            <span slot="badge">
                              <v-avatar
                                size="1"
                                :color="`${item.access ? 'success' : 'error'}`"
                              >
                              </v-avatar>
                            </span>
                              <v-icon  style="transform: scale(1.8);" :color="`${item.superadmin?'error':item.role=='admin'?'success':'primary'}`">account_circle</v-icon>
                          </v-badge>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{item.name}} - <span style="font-size:11px;">{{item.role}}</span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            {{item.email}}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar v-if="item.inf">
                          <v-chip small label 
                            color="primary" class="white--text">
                            INF
                          </v-chip>
                        </v-list-tile-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 class="text-xs-left" style="font-weight:bold;font-size:30px;">
                  INVOICE
                </v-flex>
                <v-flex xs7 class="text-xs-left" style="font-weight:bold;">
                  <span style="font-size:11px;">COMPANY: </span> ASHYAAT L.L.C
                </v-flex>
                <v-flex xs5 class="text-xs-left" style="font-weight:bold;">
                  <span style="font-size:11px;">CLIENT: </span> {{invoice.company_code}}
                </v-flex>
                <v-flex xs7 class="text-xs-left" style="font-weight:bold;">
                  <span style="font-size:11px;">DUE DATE: </span> {{invoice.date}}
                </v-flex>
                <v-flex xs5 class="text-xs-left" style="font-weight:bold;">
                  <span style="font-size:11px;">INVOICE: </span> {{invoice.code}}
                </v-flex>
                <v-flex xs12 py-5>
                  <v-layout row wrap class="text-xs-left">
                    <v-flex xs12 v-for="(item, it) in invoice.items" py-1 :key="'item-'+it">
                      <v-layout row wrap class="text-xs-left">
                        <v-flex xs3>
                          <v-text-field
                            name="Code"
                            label="Code"
                            solo
                            hide-details
                            v-model.trim="item.code"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3 px-1>
                          <v-text-field
                            name="Name"
                            label="Name"
                            solo
                            hide-details
                            v-model.trim="item.name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field
                            name="Quantity"
                            label="Quantity"
                            solo
                            @keypress="isNumber($event)"
                            hide-details
                            v-model.trim="item.quantity"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3 px-1>
                          <v-text-field
                            name="Price"
                            label="Price"
                            solo
                            @keypress="isNumber($event)"
                            hide-details
                            v-model.trim="item.price"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="primary" :disabled="!invoice.company_code" @click="()=>{
                          invoice.items.push({
                            name:'',
                            price:'',
                            code:'',
                            quantity:''
                          })
                        }">add item</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs9 class="text-xs-right" style="font-weight:bold;">
                </v-flex>
                <v-flex xs3 class="text-xs-left" style="font-weight:bold;">
                  <span style="font-size:11px;">Total: </span>
                  <span style="font-weight:bold;font-size:22px;">$
                  {{getTotal()}}</span>
                </v-flex>
                <v-flex xs12 class="text-xs-left" style="font-weight:bold;">
                  <v-checkbox label="Paid" v-model="invoice.paid" value="true" @change="setPaidDate()"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t4">
              <v-spacer></v-spacer>
              <v-btn color="success" :disabled="!invoice.company_code" @click="issueInvoice()">issue invoice to {{invoice.company_code}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data() {
    return {
      loading:false,
      users:[],
      t4:false,
      invoice:{items:[]},
      selectedUser:{},
    }
  },
  props:{
    
  },
  methods:{
    getTotal(){
      let total = 0
      let items = this.invoice.items
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        total += parseFloat(item.price) * parseFloat(item.quantity) 
      }
      return this.invoice.total = total
    },
    async loadDate(){
      this.invoice.date = await axios.get(`${apiBase}/getDate`).then(x=>x.data.date)
    },
    async setPaidDate() {
      if(this.invoice.paid) {
        this.invoice.paid_date = await axios.get(`${apiBase}/getDate`).then(x=>x.data.date)
      }
    },
    goTo(path) {
      this.$router.push(path)
    },
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async getAllUsers(){
      this.loading = true
      let a = await db.ref('users').once('value').then(x=>x.val())
      let b = Object.keys(a)
      let c = Object.values(a).map((d, i)=>{
        return {
          ...d,
          key:b[i]
        }
      })
      this.users = c
      this.loading = false

    },
    async genToken() {
      this.loading = true
      let c = await db.ref('settings/infInvoices').once('value').then(x=>x.val())
      let vtoken = `ASHYAAT_INVOICE_${randomString(4, 'aA#')}_${c}`
      this.invoice.code = vtoken
      this.loading = false
      return vtoken
    },
    setInvoiceVars() {
      this.invoice.company_code = this.selectedUser.company_code
      this.invoice.inf = this.selectedUser.key
    },
    async issueInvoice(){
      await store.collection('invoices').add(this.invoice)
      await db.ref(`settings/infInvoices`).transaction(function (current_value) {
        return (current_value || 0) + 1;
      });
      this.goTo('/inf-inovices')
    }
  },
  watch:{
    
  },
  created(){
    this.loadDate()
    this.getAllUsers()
    this.genToken()
  }
}
</script>

<style>

</style>
